import React, { useEffect, useState } from "react";
import bgImage from '../image/buy3pay2sale--deal.webp';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { Link } from "react-router-dom";

import VideoCard from './VideoCard';
import HeroSlider from "./HeroSlider";
import { FaTachographDigital } from "react-icons/fa6";
import Product from "./Products";
import Promisepage from "./Promisepage";
import Testimonialhome from "./Testimonialhome";
import CustomerReviews from "./CustomerReview";
import Category from "./Category";
import Ingredient from "./NativeIngredient";
import FeatureBlock from "./featureblock";
import FounderSection from "./founderSection";
import DeliverySlide from "./deliverySlide";
import ServiceSection from "./servicesection";
import FarmersVideo from "./framevideo";

const Home = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
 
  const testimonialData = [
    {
      custName:'Lakshmi Dev',
      custDescription:'Their ghee helped solve my acid reflux problem. While cooking with wood pressed oils imparts a unique taste and I feel lighter.',
      custImg:require('../image/1732543742.jpg'),
    },
    {
      custName:'Rahul Sharma',
      custDescription:'Their ghee helped solve my acid reflux problem. While cooking with wood pressed oils imparts a unique taste and I feel lighter.',
      custImg:require('../image/1732543742.jpg'),
    },
    {
      custName:'Anjali Varma',
      custDescription:'Their ghee helped solve my acid reflux problem. While cooking with wood pressed oils imparts a unique taste and I feel lighter.',
      custImg:require('../image/1732543742.jpg'),
    },
    {
      custName:'Ravi Kumar',
      custDescription:'Their ghee helped solve my acid reflux problem. While cooking with wood pressed oils imparts a unique taste and I feel lighter.',
      custImg:require('../image/1732543742.jpg'),
    },
    {
      custName:'Mahendra Gurjar',
      custDescription:'Their ghee helped solve my acid reflux problem. While cooking with wood pressed oils imparts a unique taste and I feel lighter.',
      custImg:require('../image/1732543742.jpg'),
    },
    {
      custName:'Deepak Nogia',
      custDescription:'Their ghee helped solve my acid reflux problem. While cooking with wood pressed oils imparts a unique taste and I feel lighter.',
      custImg:require('../image/1732543742.jpg'),
    }
  ]


  return (
    <>
      <HeroSlider/>
      <Category/>
      <Product/>
      <FeatureBlock/>
      <VideoCard />
      <Ingredient/>
     
      {/* <Promisepage/> */}
      {/* <FounderSection/> */}
      
     
      {/* <DeliverySlide/> */}
        {/* <FarmersVideo/> */}
      
      {/* <Testimonialhome/> */}
      {/* <CustomerReviews/> */}
     {/* wholesale section */}


    </>
  )
}

export default Home;